import SelectLMWH from "../../../../src/client/katnh/widgets/SelectLMWH.js";
import * as React from 'react';
export default {
  SelectLMWH,
  React
};